import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoadingDrivebComponent } from "./loading-driveb.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoadingInterceptor } from "@core/interceptors";

@NgModule({
  declarations: [LoadingDrivebComponent],
  imports: [CommonModule],
  exports: [LoadingDrivebComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    }
  ]
})
export class LoadingDrivebModule {}
